export default __webpack_public_path__ + "static/media/ru-ud.e2b0d654.svg";